import { render, staticRenderFns } from "./Devoluciones.vue?vue&type=template&id=1a043e9e&"
import script from "./Devoluciones.vue?vue&type=script&lang=ts&"
export * from "./Devoluciones.vue?vue&type=script&lang=ts&"
import style0 from "./Devoluciones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1a043e9e', component.options)
    } else {
      api.reload('1a043e9e', component.options)
    }
    module.hot.accept("./Devoluciones.vue?vue&type=template&id=1a043e9e&", function () {
      api.rerender('1a043e9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Devoluciones/Devoluciones.vue"
export default component.exports